<template>
	<div :id="svId" :class="className || ''" :style="styleObj || {}"></div>
</template>

<script>
import SVGA from "svgaplayerweb"; // 引入SVGA
let svgaId = 0; // id序号

export default {
	props: {
		urls: {
			type: Array,
			default: [],
		},
		className: {
			type: String,
			default: "",
		},
		loops: {
			type: Number,
			default: 1,
		},
		styleObj: {
			type: Object,
			default: () => {
				return {
					width: "100%",
					height: "100%",
				};
			},
		},
		mode: {
			type: String,
			default: "AspectFit",
		},
		tag: {
			type: String,
			default: "",
		},
		onFinished: {
			type: Function,
			default: null,
		},
		onFrame: {
			type: Function,
			default: null,
		},
		isPlay:{
				type: Boolean,
			default: true,
		}
	},

	data() {
		return {
			svId: `svga-id-${svgaId++}`, // 动态生成id,处理页面多个svga的情况
			player: null,
			parser: null,

			playing: false,
			svgs: [],
		};
	},
	watch: {
		urls(newV, oldV) {
			this.svgs.push(...newV);
			// console.log("watchxxxxxxxxxxxxxxxxxxxx urls", newV, this.svgs);
			if (!this.playing && newV) {
				this.$nextTick(() => this.play());
				// console.log("xxxxxxxxxxxx play");
			}
		},
		isPlay(newV, oldV){
			if(!newV){
				this.svgs = [];
				
			}
		}
	},
	created() {},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			// 创建player
			this.player = new SVGA.Player(`#${this.svId}`);
			this.player.loops = this.loops || Number.MAX_SAFE_INTEGER;
			this.player.clearsAfterStop = true;

			// 创建解析者
			this.parser = new SVGA.Parser(`#${this.svId}`);
			console.log("svga-player inited.");
		},
		play() {
			const src = this.svgs.shift() || "";
			if (!src) {
				console.log("礼物特效数据已清空");
				this.player.stopAnimation();
				this.player.clearDynamicObjects();
				return;
			}
			// console.log("gifts", this.svgs);
			this.playing = true;

			// console.log("svga params", {
			// 	src: src,
			// 	className: this.className,
			// 	loops: this.loops,
			// 	onFrame: this.onFrame,
			// 	styleObj: this.styleObj,
			// 	mode: this.mode,
			// 	tag: this.tag,
			// });

			this.parser.load(src, (videoItem) => {
				this.player.setVideoItem(videoItem);
				this.player.setContentMode(this.mode || "AspectFit");
				this.player.startAnimation();
				this.player.onFinished(() => {
					this.playing = false;
					this.onFinished?.(this.tag);
					setTimeout(() => {
						this.play();
					}, 100);
				});
				this.player.onFrame((frame) => this.onFrame?.(frame, this.tag));
			});
		},
	},
};
</script>
